import React, { createContext, useState } from 'react';

export const InteractionContext = createContext();

export const InteractionDataProvider = ({ children }) => {
  const [interaction, setInteraction] = useState({
    chat: {
      interactionId: "",
    },
    newChatButton: {
      interactionId: "",
    },
    responseFeedback: {
      interactionId: "",
    },
    logout: {
      interactionId: "",
    },
    footerFeedback: {
      interactionId: "",
    },
    tileDisplay: {
      interactionId: ""
    }
  }

  );

  const updateInteractionId = (intr) => {
    setInteraction(intr);
  }
  return (
    <InteractionContext.Provider value={{ interaction, updateInteractionId }}>
      {children}
    </InteractionContext.Provider>
  );
};